import Reveal from "./Reveal";
import { WhatsAppIcon } from "./icons";
import { WA } from "../data/site";

const PartyOrders = () => (
    <section id="party-orders" data-testid="party-orders-section" className="scroll-mt-24 bg-saga-red py-24 lg:py-28">
        <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.3em] text-saga-cream/70">Party Orders</p>
                <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-saga-cream sm:text-5xl">
                    We also accept party orders.
                </h2>
                <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-saga-cream/80 sm:text-lg">
                    For party orders and enquiries, contact us on WhatsApp.
                </p>
                <a
                    href={WA.party}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="party-orders-whatsapp-btn"
                    className="mt-10 inline-flex items-center gap-3 rounded-full bg-saga-cream px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-saga-red transition-colors hover:bg-saga-creamlight"
                >
                    <WhatsAppIcon className="h-5 w-5" />
                    Enquire on WhatsApp
                </a>
            </Reveal>
        </div>
    </section>
);

export default PartyOrders;
